import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Boost = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M7.99997 9.99984L5.99997 7.99985M7.99997 9.99984C8.93117 9.64565 9.82457 9.19898 10.6666 8.66651M7.99997 9.99984V13.3332C7.99997 13.3332 10.02 12.9665 10.6666 11.9998C11.3866 10.9198 10.6666 8.66651 10.6666 8.66651M5.99997 7.99985C6.35473 7.07945 6.80144 6.19719 7.33331 5.36649C8.11011 4.12448 9.19171 3.10185 10.4753 2.39588C11.7589 1.68991 13.2018 1.32407 14.6666 1.33315C14.6666 3.14649 14.1466 6.33315 10.6666 8.66651M5.99997 7.99985H2.66664C2.66664 7.99985 3.03331 5.97982 3.99997 5.33315C5.07997 4.61315 7.33331 5.33315 7.33331 5.33315M2.99997 10.9998C1.99997 11.8398 1.66664 14.3332 1.66664 14.3332C1.66664 14.3332 4.15997 13.9998 4.99997 12.9998C5.47331 12.4398 5.46664 11.5798 4.93997 11.0598C4.68085 10.8125 4.3395 10.6696 3.98146 10.6585C3.62341 10.6474 3.27389 10.769 2.99997 10.9998Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(Boost);
